import Swiper, {EffectFade, Controller} from 'swiper';
import Flashcards from "../components/flashcards";

const softCards = new Flashcards('.image-slide');

const softSlider = (infoSliderClass = '.js-app-text-slider', imageSliderClass = '.js-app-image-slider', btnClass = '.js-app-slider-btn', img = '.image-slide') => {
    $(imageSliderClass).height($(`${img}-active`).height());

    let textSlider = new Swiper(infoSliderClass, {
        modules: [EffectFade, Controller],
        slidesPerView: 1,
        speed: 600,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        grabCursor: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
    });

    $(btnClass).on('click', (ev) => {
        let target = $(ev.currentTarget),
            index = target.data('number');

        if(!target.hasClass('active')) {
            softCards.cardSwitching();

            $(btnClass).each((i, el) => {
                $(el).is(target) ? $(el).addClass('active') : $(el).removeClass('active');
            })

            textSlider.slideToLoop(index);
        }
    })

    softCards.init();
    $(window).on('resize', function () {
        $(imageSliderClass).height($(`${img}-active`).height());
    })

}

export default softSlider;
